import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { crmDataService } from "../HR/CRM/utils/crmDataService";
import "./MyTickets.css";

function MyTickets() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMyTickets = async () => {
      try {
        setLoading(true);
        const userEmail = localStorage.getItem("userEmail");

        // Fetch tickets - same pattern as ToDoTickets and CRMTickets
        const result = await crmDataService.searchTickets({
          requesterEmail: userEmail,
          limit: 50
        });

        // Handle both array and paginated response formats
        const ticketList = Array.isArray(result) ? result : (result.tickets || []);

        // Filter for active statuses (New, In Progress, Pending) on the frontend
        const activeStatuses = ["New", "In Progress", "Pending"];
        const activeTickets = ticketList
          .filter(ticket => activeStatuses.includes(ticket.status))
          .slice(0, 5);

        setTickets(activeTickets);
      } catch (error) {
        console.error("Error fetching tickets:", error);
        setTickets([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMyTickets();
  }, []);

  const getStatusClass = (status) => {
    const statusLower = status?.toLowerCase().replace(/\s+/g, "-") || "";
    return `status-badge status-${statusLower}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  };

  const handleTicketClick = (ticketNumber) => {
    navigate(`/hr/crm/tickets/${ticketNumber}`);
  };

  const handleViewAll = () => {
    navigate("/hr/crm/tickets");
  };

  if (loading) {
    return (
      <div className="my-tickets-container">
        <div className="my-tickets-loading">
          <div className="loading-spinner"></div>
          <span>Loading tickets...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="my-tickets-container">
      {tickets.length === 0 ? (
        <div className="my-tickets-empty">
          <div className="empty-icon">📋</div>
          <p>No active tickets found</p>
          <span>Your New, In Progress, and Pending tickets will appear here</span>
        </div>
      ) : (
        <>
          <div className="my-tickets-table-wrapper">
            <table className="my-tickets-table">
              <thead>
                <tr>
                  <th>Ticket #</th>
                  <th>Subject</th>
                  <th>Category</th>
                  <th>Subcategory</th>
                  <th>Status</th>
                  <th>Created</th>
                </tr>
              </thead>
              <tbody>
                {tickets.map((ticket, index) => (
                  <tr
                    key={ticket.id || index}
                    onClick={() => handleTicketClick(ticket.ticket_number)}
                  >
                    <td className="ticket-number-cell">
                      {ticket.ticket_number}
                    </td>
                    <td className="ticket-subject-cell">
                      <div className="ticket-subject">{ticket.title}</div>
                      {ticket.team_code && (
                        <div className="ticket-team">{ticket.team_code}</div>
                      )}
                    </td>
                    <td className="ticket-category-cell">
                      {ticket.category_name || "-"}
                    </td>
                    <td className="ticket-subcategory-cell">
                      {ticket.subcategory_name || "-"}
                    </td>
                    <td>
                      <span className={getStatusClass(ticket.status)}>
                        {ticket.status}
                      </span>
                    </td>
                    <td className="ticket-date-cell">
                      {formatDate(ticket.created_at)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="my-tickets-footer">
            <button className="view-all-btn" onClick={handleViewAll}>
              View All Tickets →
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default MyTickets;
